import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/board/notice/'

let swrData: any = getPersistData(KEY)

export function useNoticeInfo(nocticeId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + nocticeId,
		async () => {
			const response = await API.get(KEY + nocticeId, token + '', {})
			swrData = response.result?.result

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		noticeInfo: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}